import BaseLayer from "./BaseLayer";
import {plotDisagreementsHelper} from "../utils/map_utils";

class StitchPostRound3Disagreementv2 extends BaseLayer {

    id = "stitchPostRound3Disagreementv2";
    label = "After";
    defaultVisible = this.props.tileViewerState[this.id];

    draw = () => new Promise((resolve, reject) => {
        let {stitchPostR3Disagreement, textColor} = this.props;
        plotDisagreementsHelper(stitchPostR3Disagreement.result, this.props.slide, this.layer.getSource(), textColor);
        resolve();
    });
}

export default StitchPostRound3Disagreementv2;
